"use client";

import { Panchang } from "@/components/panchang";
import RatingPrompt from "@/components/RatingPrompt";
import type { PanchangResponse } from "@/lib/api";

export default function PanchangClient({
  latitude = 28.6139,
  longitude = 77.209,
  defaultLanguage = "en",
  initialDate,
  initialDisplayDate,
  initialResult,
}: {
  latitude?: number;
  longitude?: number;
  defaultLanguage?: "en" | "hi";
  initialDate?: string;
  initialDisplayDate?: string;
  initialResult?: PanchangResponse | null;
}) {
  return (
    <>
      <div className="intent-interface-timing-first min-h-[calc(100vh-130px)]">
        <Panchang
          latitude={latitude}
          longitude={longitude}
          language={defaultLanguage}
          initialDate={initialDate}
          initialDisplayDate={initialDisplayDate}
          initialResult={initialResult}
        />
      </div>
      <div style={{ maxWidth: 640, margin: "0 auto", padding: "0 16px 24px" }}>
        <RatingPrompt
          source={"tool_result" as never}
          mode="thumbs+text"
          prompt="Was today's Panchang accurate?"
          context={{
            surface: "panchang_result",
            path: typeof window !== "undefined" ? window.location.pathname : null,
          }}
        />
      </div>
    </>
  );
}
